import { InjectionToken } from '@angular/core';

export const NOTIFICATION = new InjectionToken<typeof Notification>('NOTIFICATION_TOKEN', {
  providedIn: 'root',
  factory: () => {
    return Notification;
  },
});
